import { render, staticRenderFns } from "./content-image-editor.vue?vue&type=template&id=0c1b5dba&scoped=true"
import script from "./content-image-editor.ts?vue&type=script&lang=ts&external"
export * from "./content-image-editor.ts?vue&type=script&lang=ts&external"
import style0 from "./content-image-editor.less?vue&type=style&index=0&id=0c1b5dba&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1b5dba",
  null
  
)

export default component.exports